module.exports = __webpack_public_path__ + "cross.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/cross.svg?color1=%23333333&color2=
// module id = 2194
// module chunks = 67